import axios from "axios";
import EnvDetails from "./env_config";

const baseURL = EnvDetails.getServerConfigs();

const apiService = axios.create({
  baseURL: baseURL, // Update base URL to your API server
  headers: {
    "Content-Type": "application/json",
  },
});

// Intercept requests (Optional)
apiService.interceptors.request.use(
  (config) => {
    // Add token or headers if needed
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercept responses (Optional)
apiService.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Exporting methods
export const api = {
  get: (url, params) => apiService.get(url, { params }),
  post: (url, data) => apiService.post(url, data),
  put: (url, data) => apiService.put(url, data),
  delete: (url) => apiService.delete(url),
};
